import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero, SectionHeading } from "@/components/common";
import { OrgCard } from "@/components/OrgCard";
import { useSEO } from "@/lib/useSEO";
import { ORGANIZATIONS } from "@/config/site";

const contributions = {
  ATS: "ATS drives the Group's technology capability — delivering IT services and digital solutions that help businesses build, modernize and scale.",
  ASAI: "ASAI powers the future-skills mission — equipping learners with practical, industry-oriented AI and emerging-technology skills.",
  AIMT: "AIMT anchors higher education — building strong academic foundations and career-ready professional capabilities.",
  FOUNDATION: "Atmasamman Foundation carries the Group's social mission — extending education, skills and awareness into communities.",
};

export default function Organizations() {
  useSEO({
    title: "Our Organizations | Atmasamman Group",
    description: "Discover ATS | IT Solutions, ASAI, AIMT and Atmasamman Foundation — the organizations that make up the Atmasamman Group ecosystem.",
    path: "/organizations",
  });

  return (
    <Layout>
      <PageHero eyebrow="Our Organizations" title="Our Organizations"
        subtitle="Four organizations, one shared vision. Explore how each contributes to the broader Atmasamman ecosystem." />

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl space-y-8 px-4 sm:px-6 lg:px-8">
          {ORGANIZATIONS.map((org) => (
            <div key={org.code} className="grid gap-6 lg:grid-cols-5 lg:gap-8">
              <div className="lg:col-span-3"><OrgCard org={org} detailed /></div>
              <div className="flex flex-col justify-center rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6 lg:col-span-2 md:p-8">
                <SectionHeading eyebrow={`Role in the ecosystem`} title={org.name} />
                <p className="mt-4 text-base leading-relaxed text-slate-600">{contributions[org.code]}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
